import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IStatusExecution, StatusExecutionMapper } from '@modules/status';

export type IGetOrderStatusExecutionRepoResponse = IRepoResponse<200, IStatusExecution[]> | IRepoResponse<400 | 500, string>;

export type IGetOrderStatusExecutionRepoInput = { id: string | number };

export type IGetOrderStatusExecutionRepo = IRepo<[IGetOrderStatusExecutionRepoInput], IGetOrderStatusExecutionRepoResponse>;

export const GetOrderStatusExecutionRepoType = Symbol.for('GetOrdersStatusExecutionRepo');

@bind(GetOrderStatusExecutionRepoType)
export class GetOrdersStatusExecutionRepo implements IGetOrderStatusExecutionRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute({ id }) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/orders/getstates', { order_id: id }) });

      if (result.status === 200) {
        const data: IStatusExecution[] = result.data.data.map((item) => StatusExecutionMapper.toDomain(item));

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
